module.exports = __webpack_public_path__ + "img/d40911c.jpg";